export var JoveLanguageEnum;

(function (JoveLanguageEnum) {
  JoveLanguageEnum["EN"] = "en";
  JoveLanguageEnum["FR"] = "fr";
  JoveLanguageEnum["ES"] = "es";
  JoveLanguageEnum["ES_ES"] = "es-ES";
  JoveLanguageEnum["PT"] = "pt-PT";
  JoveLanguageEnum["DE"] = "de";
  JoveLanguageEnum["NL_BE"] = "nl-BE";
  JoveLanguageEnum["NL_NL"] = "nl-NL";
  JoveLanguageEnum["BG"] = "bg";
  JoveLanguageEnum["AT"] = "de-AT";
  JoveLanguageEnum["HR"] = "hr";
  JoveLanguageEnum["CY"] = "el";
  JoveLanguageEnum["CZ"] = "cs";
  JoveLanguageEnum["DK"] = "da";
  JoveLanguageEnum["EE"] = "et";
  JoveLanguageEnum["FI"] = "fi";
  JoveLanguageEnum["GR"] = "el";
  JoveLanguageEnum["HU"] = "hu";
  JoveLanguageEnum["IE"] = "ga";
  JoveLanguageEnum["IT"] = "it";
  JoveLanguageEnum["LV"] = "lv";
  JoveLanguageEnum["LT"] = "lt";
  JoveLanguageEnum["LU"] = "lb";
  JoveLanguageEnum["MT"] = "mt";
  JoveLanguageEnum["PL"] = "pl";
  JoveLanguageEnum["RO"] = "ro-RO";
  JoveLanguageEnum["SK"] = "sk";
  JoveLanguageEnum["SL"] = "sl";
  JoveLanguageEnum["SE"] = "sv";
  JoveLanguageEnum["NO"] = "no";
})(JoveLanguageEnum || (JoveLanguageEnum = {}));